import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function UykuKalitesiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['uyku-kalitesi-testi']} />;
}
